import {
  getString,
} from "@surya-digital/leo-ts-types";

export interface EmbedCodeDTO {
  code: string;
}

export class EmbedCode {
  readonly isEmbedCodeEmbedCode: boolean = true;

  readonly code: string;

  static readonly constraints = {
    "code": {
      "minSize": 4,
      "maxSize": 1000,
      
      
      
      
    }
  }

  constructor(
  code: string
  ) {
    EmbedCode.validateCode(code);
    this.code = code;
  }

  static fromDTO(dto: EmbedCodeDTO): EmbedCode {
    const code = getString(dto, "code", InvalidEmbedCodeCodeError);
    return new EmbedCode(
      code
    );
  }

  toDTO(): EmbedCodeDTO {
    const dto: EmbedCodeDTO = {
        code: this.code
    };
    return dto;
  }
  private static validateCode = (code: string): void => {
    if(code.length < 4) {
      throw new InvalidEmbedCodeCodeMinSizeError(
        4,
        `Attribute code is too short. Size is ${code.length}. Min size is 4.`
      );
    }
    if(code.length > 1000) {
      throw new InvalidEmbedCodeCodeMaxSizeError(
        1000,
        `Attribute code is too long. Size is ${code.length}. Max size is 1000.`
      );
    }
      if(code.trim().length === 0) {
        throw new InvalidEmbedCodeCodeNonEmptyError(
          `Attribute code cannot be an empty string.`
        );
      }
  }
  
}

EmbedCode.prototype.toString = function toString(): string {
  return `EmbedCode(code='${this.code}')`;
};

export class InvalidEmbedCodeError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmbedCodeError";
  }
}
export class InvalidEmbedCodeCodeError extends InvalidEmbedCodeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmbedCodeCodeError";
  }
}

export class InvalidEmbedCodeCodeMaxSizeError extends InvalidEmbedCodeCodeError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmbedCodeCodeMaxSizeError";
  }
}

export class InvalidEmbedCodeCodeMinSizeError extends InvalidEmbedCodeCodeError {
  readonly minSize: number;
  constructor(minSize: number, message?: string) {
    super(message);
    this.minSize = minSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmbedCodeCodeMinSizeError";
  }
}

export class InvalidEmbedCodeCodeNonEmptyError extends InvalidEmbedCodeCodeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmbedCodeCodeNonEmptyError";
  }
}
